import type { MatchFilterStatus } from './eventMatchesView';
export interface MatchFilterUrl {
  day: string | null;
  query: string;
  division: string;
  venue: string;
  status: MatchFilterStatus | '';
  following: boolean;
}
const keys = ['day', 'q', 'division', 'venue', 'status', 'following'] as const;
/** URL state carries preferences only; following always resolves against the current session. */
export function parseMatchFilterUrl(params: URLSearchParams): MatchFilterUrl {
  const single = (key: string) => (params.getAll(key).length === 1 ? params.get(key)! : '');
  const rawDay = single('day');
  const date = /^\d{4}-\d{2}-\d{2}$/.test(rawDay) ? new Date(rawDay) : null;
  const day =
    date && Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === rawDay
      ? rawDay
      : null;
  const status = single('status');
  return {
    day,
    query: single('q').slice(0, 250),
    division: single('division').slice(0, 100),
    venue: single('venue').slice(0, 100),
    status: status === 'upcoming' || status === 'live' || status === 'finished' ? status : '',
    following: single('following') === '1',
  };
}
export function serializeMatchFilterUrl(
  params: URLSearchParams,
  state: MatchFilterUrl,
): URLSearchParams {
  const next = new URLSearchParams(params);
  keys.forEach((key) => next.delete(key));
  if (state.day) next.set('day', state.day);
  if (state.query) next.set('q', state.query);
  if (state.division) next.set('division', state.division);
  if (state.venue) next.set('venue', state.venue);
  if (state.status) next.set('status', state.status);
  if (state.following) next.set('following', '1');
  return next;
}
